export default __webpack_public_path__ + "static/media/payment-arrow.63ed2f74.svg";